import React, { useMemo, useState } from "react";
import "./Header.css";

const METHODS = [
  { value: "home", label: "Rút tại nhà — phí 1.3%", feeRate: 0.013 },
  { value: "online", label: "Rút online — phí 1%", feeRate: 0.01 },
];

const formatMoney = (value) =>
  new Intl.NumberFormat("vi-VN").format(value) + " đ";

export default function Header() {
  const [amount, setAmount] = useState(1000000);
  const [method, setMethod] = useState(METHODS[0].value);

  const selectedMethod =
    METHODS.find((item) => item.value === method) || METHODS[0];

  const fee = useMemo(
    () => Math.round(amount * selectedMethod.feeRate),
    [amount, selectedMethod],
  );

  const received = useMemo(() => amount - fee, [amount, fee]);

  return (
    <section className="hero-calc">
      <div className="hero-calc__container">
        <div className="hero-calc__grid">
          <div className="hero-calc__content">
            <h1 style={{ textAlign: "center" }} className="hero-calc__title">
              <span>Dịch Vụ Đáo Rút Thẻ</span>
              <br />
              <span>Phí rẻ Chạm Đáy</span>
              <br />
              <span>Chào Mừng Bạn!</span>
            </h1>
            <div className="mota">
              <p>1% thấp nhất thị trường.</p>
              <p>So sánh và thấy ngay: chúng tôi luôn rẻ hơn.</p>
              <p>Nếu nơi khác báo phí thấp hơn, chúng tôi khớp giá.</p>
            </div>

            <div className="hero-calc__image">
              <img src="/1234.webp" alt="Dịch vụ rút tiền thẻ tín dụng" />
            </div>
          </div>
        </div>
        <div className="process-cta">
          <div className="process-cta__actions">
            <a
              onClick={() => {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                  event: "goi",
                });
              }}
              href="tel:0941395019"
              className="cta-btn cta-btn--call"
            >
              📞 Gọi ngay 0941 395 019
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
